var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeAvatar5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0456,
    cy: 35.0454,
    r: 33.3766,
    fill: "#DFEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0676 25.283C53.8807 24.1168 52.1178 23.9211 50.6899 24.6179L46.0433 20.0359C46.3445 18.1227 45.7676 16.0998 44.277 14.6291C41.7963 12.1829 37.7571 12.1829 35.2772 14.6291C34.7801 15.1193 34.7801 15.9132 35.2772 16.4035C36.6678 17.7746 35.95 21.0666 34.378 22.6168L29.649 27.28C27.9938 28.9665 28.4511 31.1341 29.7593 32.4024C30.4855 33.1068 31.5087 33.5644 32.5726 33.5644C33.1079 33.5644 33.6492 33.4314 34.1701 33.1737L37.8886 36.8397C36.0442 38.4953 34.1099 39.1102 31.8871 39.7694C29.1366 40.5842 26.0205 41.5087 22.7788 44.7044L18.3621 49.2044C16.8731 50.6726 16.8731 53.0594 18.3621 54.5276C19.851 55.9959 22.2714 55.9959 23.7604 54.5276L26.5431 51.6389C29.9519 48.2775 32.615 47.6032 35.1924 46.9515C37.377 46.3985 39.6363 45.8263 41.865 43.6294L55.0676 30.6104C56.5566 29.1422 56.5566 26.7521 55.0676 25.283ZM39.7194 35.0954L36.1197 31.5466L37.9191 29.7722L41.5189 33.321L39.7194 35.0954ZM43.3183 31.5466L39.7186 27.9978L41.5189 26.2225L45.1177 29.7722L43.3183 31.5466ZM46.918 27.9978L43.3191 24.4481L44.277 23.5036C44.5654 23.2192 44.8123 22.9105 45.0337 22.5892L48.7183 26.2225L46.918 27.9978Z",
    fill: "#307F92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9187 29.7279L36.1193 31.5029L39.7193 35.0516L41.5187 33.2767L37.9187 29.7279Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3179 31.5047L39.7181 27.9559L41.5184 26.1807L45.1173 29.7303L43.3179 31.5047Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9167 27.9559L43.3179 24.4063L44.2757 23.4618C44.5641 23.1773 44.811 22.8686 45.0325 22.5474L48.717 26.1807L46.9167 27.9559Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAvatar5);
export default __webpack_public_path__ + "static/media/Office-Avatar-5.a6a7f9a1ccbaf32cbbaccac091aa133b.svg";
export { ForwardRef as ReactComponent };